import { render, staticRenderFns } from "./BiddingTypeInfo.vue?vue&type=template&id=03551eba&scoped=true"
import script from "./BiddingTypeInfo.vue?vue&type=script&lang=js"
export * from "./BiddingTypeInfo.vue?vue&type=script&lang=js"
import style0 from "./BiddingTypeInfo.vue?vue&type=style&index=0&id=03551eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03551eba",
  null
  
)

export default component.exports